import Icon from '../components/Icon.vue'

Icon.register({
  tag: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 252.1v-204.1c0-26.5 21.5-48 48-48h204.1c11 0 26.2 6.3 33.9 14.1l211.9 211.9c18.7 18.7 18.7 49.1 0 67.9l-204.1 204.1c-18.7 18.7-49.1 18.7-67.9 0l-211.9-211.9c-7.8-7.8-14.1-23-14.1-33.9zM112 64c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tag.js
// module id = 1981
// module chunks = 0